import React from 'react';

const InvoiceHeader = ({ supplier, isEditable, setInvoiceData }) => {
  return (
    <div className="invoice-header">
      <div className="invoice-logo">
        <img src="/logo.png" alt="Vidyutcloud Logo" />
      </div>
      <div className="supplier-details">
        <h2>{supplier.name}</h2>
        <p>{supplier.address}</p>
        <p>GSTIN: {supplier.gstin} | PAN: {supplier.pan}</p>
        <p>Contact: {supplier.contact} | Email: {supplier.email}</p>
      </div>
    </div>
  );
};

export default InvoiceHeader;